module.exports = __webpack_public_path__ + "static/img/dbbj.1691d24e.png";